import { Grid, TableCell, darken } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { COLORS } from "src/_globalStore/redux/reducers/Theme/themeConstants";

export const Container = styled(Grid)(({ theme }) => ({
  overflow: "auto",
  marginTop: "20px",
  "& .MuiTableHead-root": {
    "& .MuiTableRow-root": {
      height: "56px",
      "& .MuiTableCell-root": {
        backgroundColor: theme.palette.background.paper,
        "&:first-of-type": {
          borderRadius: "12px 0px 0px 12px",
        },
        "&:last-of-type": {
          borderRadius: "0px 12px 12px 0px",
        },
        "& .MuiTypography-root": {
          fontWeight: 500,
        },
      },
    },
  },

  "& .MuiTableRow-root": {
    "& .MuiTableCell-root": {
      borderBottom: `1px solid ${darken(COLORS.black_gradients.greyLight, 0.05)}`,

      "&:first-of-type": {
        textAlign: "center",
        padding: 0,
      },
      "&:not(:last-of-type)": {
        borderRight: `1px solid ${darken(COLORS.black_gradients.greyLight, 0.025)}`,
      },
    },
  },
}));

export const TableContainer = styled(Grid)({
  width: "100%",
  minWidth: "500px",
});

export const TableContentsContainer = styled(Grid)({
  width: "100%",
  minWidth: "500px",
});
export const Column = styled(Grid)({
  paddingLeft: "10px",

  "&  p": {
    fontWeight: 500,
    fontSize: "14px",
  },
});

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "align",
})<{ align?: "left" | "center" | "right"; width?: number }>(
  { height: "55px" },
  ({ width, theme }) => ({
    ...(!!width && {
      width: `${width}%`,
    }),
  }),
  ({ align, theme }) => ({
    ...(!!align && {
      textAlign: align,
    }),
  })
);

export const ColumnsContainer = styled(Grid)({
  display: "flex",
  width: "100%",
  flexWrap: "nowrap",
  height: "60px",
  alignItems: "center",

  "&>div": {
    flexShrink: "unset",
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
});

export const TotalContainer = styled(Grid)(({ theme }) => ({
  height: "60px",
  paddingLeft: "10px",
  alignItems: "center",
  backgroundColor: alpha(theme.palette.secondary.light, 0.9),
}));

export const TitleContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",

  "&:hover div": {
    display: "block",
  },
});

export const SortContainer = styled(Grid)({
  display: "none",
  "&:hover": {
    cursor: "pointer",
  },
});
